module.exports = __webpack_public_path__ + "static/img/sy02.69a0e695.png";